import { gsap } from "gsap";
let isPlaying;
document.addEventListener("click", (e) => {
  if (e.target.closest(".js-tab-trigger")) {
    if (e.target.closest(".js-tab-trigger").classList.contains("tabs__button--active")) return;
    if (isPlaying) return;
    const id = e.target.dataset.tabTrigger;
    const items = document.querySelectorAll("[data-tab]");
    const target = document.querySelectorAll(`[data-tab="${id}"]`);
    isPlaying = true;
    document.querySelectorAll(".js-tab-trigger").forEach((elem) => {
      elem.classList.remove("tabs__button--active");
    });
    e.target.closest(".js-tab-trigger").classList.add("tabs__button--active");
    items.forEach((elem) => {
      elem.style.display = "none";
    });
    target.forEach((elem) => {
      const list = elem.querySelector(".tabs-list");
      const image = elem.querySelector("img");
      const tl = gsap.timeline();
      console.log(elem);
      tl.fromTo(
        elem,
        {
          display: "none",
        },
        {
          display: "block",
        }
      );
      tl;
      tl.fromTo(
        elem.querySelectorAll(".tabs-list__item,.tabs__desc"),
        {
          opacity: 0,
          x: -100,
        },
        {
          stagger: 0.1,

          opacity: 1,
          x: 0,
        },
        "<"
      );
      tl.fromTo(
        image,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          onComplete: () => {
            isPlaying = false;
          },
        },
        "<"
      );
    });
  }
});
